import styled from 'styled-components';
import React from 'react';
import { LoadingIndicator, Type } from '@spotify-internal/encore-web';
import { TextDir } from '../../design_system/TextDir';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.5rem;
`;
export const StyledTitle = styled(Type) `
  text-align: center;
  color: #a7a7a7;
`;
const Loading = styled(LoadingIndicator) `
  margin-bottom: 1rem;
`;
export const MetadataMessage = ({ text, loading = false, }) => (React.createElement(Container, null,
    React.createElement(StyledTitle, { "data-testid": "metadata-message", as: StyledTitle, variant: "mesto", weight: "book", paddingBottom: "12px" },
        React.createElement(TextDir, null, text)),
    loading && React.createElement(Loading, null)));
